import React from "react";
import { Input, Select, DatePicker, Upload, Button, Checkbox } from "antd";
import { UploadOutlined } from "@ant-design/icons";
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import {Calendar} from "@nextui-org/react";
import dayjs from "dayjs";
import moment from "moment/moment";

const { Option } = Select;

const InputField = ({
  type = "text",
  label,
  value,
  onChange,
  placeholder,
  error,
  cssClass = "",
  required = false,
  maxLength,
  options,
  showCheckbox,
  onCheckboxChange, // Add a prop for checkbox handling
  className,
  disabled,
  rows,
  ...rest
}) => {
  const handleChange = (e) => {
    if (e && e.target) {
      // Handles Input, Checkbox, and other normal inputs
      onChange(e.target.value);
    } else {
      // Handles Select component where onChange gives the value directly
      onChange(e);
    }
  };

  //   const onChange = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  const handleFileChange = (info) => {
    if (info.fileList) {
      // Handle file upload logic here if needed
    }
  };

  const monthFormat = "YYYY/MM";

  return (
    <div className={`input-field ${cssClass}`}>
      <div className="d-flex flex-row gap-3">
        {label && (
          <label>
            {label}
            {required && <span style={{ color: "red" }}> *</span>}
          </label>
        )}
        {showCheckbox && (
          <Checkbox
            onChange={onCheckboxChange}
            className="align-middle font-medium"
          >
            Same as WhatsApp Number
          </Checkbox>
        )}
      </div>

      {type === "select" ? (
        <Select
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
              disabled={disabled}   

          {...rest}
          //    style={{  /*marginTop: "10px"*/ }}
          className="input-default w-100"
        >
          {options &&
            options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
        </Select>
      ) 
      
      
      

 : type === "textarea" ?(
  <textarea
    className={`w-full border rounded px-3 py-2 resize-y outline-none 
                text-left align-top leading-relaxed whitespace-pre-wrap 
                min-h-[140px] ${className || ""}`}
    rows={rows || 5}
    value={value}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    required={required}
                  disabled={disabled}   

  />
)


      
      
      
      
      
      
      
     :  type === "file" ? (
        <Upload
          action="/upload" // This should be your file upload endpoint
          listType="picture"
          onChange={handleFileChange}
          showUploadList={false} // Hide the list of uploaded files
          {...rest}
        >
          <Button icon={<UploadOutlined />}>{placeholder || "Upload"}</Button>
        </Upload>
      ) : type === "datetwo" ? (
        // <DatePicker.RangePicker
        // className="input-default"
        //   placeholder={['', 'Till Now']}
        //   allowEmpty={[false, true]}
        //   onChange={(date, dateString) => {
        //     console.log(date, dateString);
        //   }}
        // />

        <DatePicker
          value={value ? dayjs(value) : null}
          format="YYYY/MM"
          picker="month"
          onChange={onChange}
          className="input-default w-100"
          disabled={disabled}
          disabledDate={(current) => {
            const startDate = dayjs("1985-04-01");
            return current && (current > dayjs() || current < startDate);
          }}
        />
      ) : // ORIGINAL -
      // <DatePicker
      // defaultValue={dayjs('YYYY/MM', monthFormat)} format={monthFormat} picker="month" onChange={onChange} className="input-default w-100" />








    type === "date" ? (
        // <LocalizationProvider dateAdapter={AdapterDayjs}>
        //   <DemoContainer components={['DatePicker']}>
        //     <DatePicker
        //       label={'"year", "month" and "day"'}
        //       views={['year', 'month', 'day']}
        //     />
        //   </DemoContainer>
        // </LocalizationProvider>

        // <Calendar showMonthAndYearPickers aria-label="Date (Show Month and Year Picker)" />
        <DatePicker
          value={value ? dayjs(value) : null}
          className="input-default w-100"
          format="YYYY-MM-DD"
          onChange={(date, dateString) => onChange(dateString)}
          disabled={disabled}
          // disabledDate={(current) => {
          //   const startDate = dayjs("1940-01-01");
          //   const fixedDate = dayjs("2005-01-01");
          //   return current && (current > fixedDate || current < startDate);
          // }}
        />
      ) : (
        <Input
          type={type}
          value={value}
          onChange={(e) => handleChange(e)}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          className={className}
          // className="input-default w-100"
          disabled={disabled}
          {...rest}
        />





      )}




      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default InputField;
